// InstitutionForm.form.js
import * as Yup from "yup";

export function initialValues(user, institution, isNew) {
  return {
    institutionnam: isNew ? "" : institution?.institutionnam || "",
    address: isNew ? "" : institution?.address || "",
    city: isNew ? "" : institution?.city || "",
    country: isNew ? "" : institution?.country || "",
    phone: isNew ? "" : institution?.phone || "",
    website: isNew ? "" : institution?.website || "",
    avatar: isNew ? "" : institution?.avatar || "",
    fileAvatar: null,
    firstname: isNew ? "" : institution?.firstname || "",
    lastname: isNew ? "" : institution?.lastname || "",
    email: isNew ? "" : institution?.email || "",
    role: "institution",
    partnerId: user.user._id, // asumes que user.user existe
    password: "",
    planEducaId: isNew ? "" : institution?.planEduca?._id || "",
    studentsnum: isNew ? "" : institution?.studentsnum || "",
    teachersnum: isNew ? "" : institution?.teachersnum || "",
  };
}

export function validationSchema(institution, t) {
  return Yup.object({
    institutionnam: Yup.string().required(t("institutions:validation.institutionRequired")),
    phone: Yup.string()
      .matches(/^[0-9]+$/, t("institutions:validation.phoneOnlyNumbers"))
      .min(9, t("institutions:validation.phoneMin"))
      .required(t("institutions:validation.phoneRequired")),
    city: Yup.string().required(t("institutions:validation.cityRequired")),
    planEducaId: Yup.string().required(t("institutions:validation.planRequired")),
    firstname: Yup.string().required(t("institutions:validation.nameRequired")),
    lastname: Yup.string().required(t("institutions:validation.lastNameRequired")),
    email: Yup.string()
      .email(t("institutions:validation.emailInvalid"))
      .required(t("institutions:validation.emailRequired")),
    partnerId: Yup.string().required(t("institutions:validation.partnerIdRequired")),
    password: institution
      ? Yup.string()
      : Yup.string().required(t("institutions:validation.passwordRequired")),
  });
}
